import { Link } from "react-router-dom";
import { Sparkles, Moon, Compass } from "lucide-react";
import SocialProof from "@/components/earthpulse/SocialProof";
import useSubscription from "@/hooks/useSubscription";

export default function BirthChartTeaser() {
  const { active: subActive } = useSubscription();
  const ctaTo = subActive ? "/birth-chart" : "/subscribe";
  const ctaLabel = subActive ? "Open your birth chart" : "Start membership · £8.88 / mo";
  const subCopy = subActive
    ? "Included with your Earth Pulse membership · unlimited readings."
    : "£8.88 / month · unlimited Birth Charts & Compatibility · cancel any time.";

  return (
    <div
      className="parchment-card rounded-2xl p-10 md:p-14 relative overflow-hidden"
      data-testid="birth-chart-teaser"
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
        <div className="md:col-span-7">
          <div className="label-overline constellation-underline">A Personal Reading</div>
          <h2 className="mt-4 font-serif-display text-[color:var(--parchment)] text-3xl md:text-5xl leading-[1.05] tracking-tight">
            Your <span className="font-serif-italic text-[color:var(--gold)]">cosmic</span> birth chart,
            written in warm light.
          </h2>
          <p className="mt-5 text-[color:var(--parchment-soft)] text-base md:text-lg max-w-xl font-sans-body leading-relaxed">
            The sky held a particular shape the moment you arrived. We compute your Sun, Moon and
            Rising placements and our proprietary narrative engine writes you a literary reading of what they
            mean — gifts, shadows, and a single affirmation to carry.
          </p>
          <div className="mt-8 flex items-center gap-4 flex-wrap">
            <Link
              to={ctaTo}
              data-testid="birth-chart-cta"
              className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-[color:var(--gold)] hover:bg-[color:var(--gold-soft)] text-[color:var(--bg-base)] font-sans-body text-sm tracking-wide"
              style={{ transition: "background-color 200ms ease" }}
            >
              {ctaLabel}
            </Link>
            <span className="font-serif-italic text-[color:var(--text-secondary)]">
              {subCopy}
            </span>
          </div>
          <div className="mt-6">
            <SocialProof compact />
          </div>
        </div>

        <div className="md:col-span-5">
          <div className="grid grid-cols-3 gap-4">
            {[
              { icon: Sparkles, label: "Sun", note: "your core self" },
              { icon: Moon, label: "Moon", note: "your inner world" },
              { icon: Compass, label: "Rising", note: "how you meet the world" },
            ].map((x) => (
              <div
                key={x.label}
                className="rounded-xl border border-[color:var(--gold)]/20 p-5 text-center hover-lift"
                style={{ background: "rgba(10, 17, 40, 0.6)" }}
              >
                <x.icon className="mx-auto text-[color:var(--gold)]" size={22} />
                <div className="mt-3 font-serif-display text-white text-lg">{x.label}</div>
                <div className="font-serif-italic text-[color:var(--text-secondary)] text-sm mt-1">
                  {x.note}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
